import { useTranslation } from '@frontend/i18n';

export const StripePrivacyPolicyFooter = () => {
  const { t } = useTranslation('weave-pay');

  return (
    <a href='https://stripe.com/us/privacy' target='_blank' rel='noopener noreferrer'>
      {t('Privacy Policy')}
    </a>
  );
};
